import React from 'react';
import PageWithoutSidebars from '../Page/PageWithoutSidebars.jsx';
import XLBYGMeta from './XLBYGMeta';

const id = '72283290485360';
const origin = 'https://form.jotformeu.com';

export default class XLBYG extends React.PureComponent {
  constructor() {
    super();

    this.state = {
      iframe: null,
      height: '0px',
    };
    this.handleIFrameMessage = this.handleIFrameMessage.bind(this);
  }

  handleIFrameMessage(e) {
    const iframe = this.state.iframe;
    if (!iframe) {
      return;
    }
    if (e.origin === `${origin}`) {
      console.log(e);
      const args = e.data.split(':');

      switch (args[0]) {
      case 'scrollIntoView':
        iframe.scrollIntoView();
        break;
      case 'setHeight':
        this.setState({ height: `${args[1]}px` });
        break;
      case 'collapseErrorPage':
        if (iframe.clientHeight > window.innerHeight) {
          this.setState({ height: `${window.innerHeight}px` });
        }
        break;
      case 'reloadPage':
        window.location.reload();
        break;
      default:
      }
      // var isJotForm = e.origin.indexOf('jotform') > -1 ? true : false;
      // if (
      //   isJotForm &&
      //   'contentWindow' in iframe &&
      //   'postMessage' in iframe.contentWindow
      // ) {
      //   var urls = {
      //     docurl: encodeURIComponent(document.URL),
      //     referrer: encodeURIComponent(document.referrer),
      //   };
      //   iframe.contentWindow.postMessage(
      //     JSON.stringify({ type: 'urls', value: urls }),
      //     '*',
      //   );
      // }
    }
  }

  componentDidMount() {
    window.addEventListener('message', this.handleIFrameMessage, false);
  }
  componentWillUnmount() {
    window.removeEventListener('message', this.handleIFrameMessage);
  }

  render() {
    return (
      <PageWithoutSidebars>
        <div className="xl-byg">
          <XLBYGMeta />
          <iframe
            id={`JotFormIFrame-${id}`}
            onLoad={() => window.scrollTo(0, 0)}
            ref={ref => this.setState({ iframe: ref })}
            allowTransparency="true"
            src={`${origin}/${id}`}
            frameBorder="0"
            scrolling="no"
            style={{
              border: 'none',
              width: '100%',
              height: this.state.height,
            }}
          />
        </div>
      </PageWithoutSidebars>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/XLBYG/XLBYG.jsx